import dayjs from "dayjs"
import "dayjs/locale/de"
import "dayjs/locale/en"
import "dayjs/locale/fr"
import "dayjs/locale/nl"

import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
// import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
// import relativeTime from "dayjs/plugin/relativeTime"
// import localizedFormat from "dayjs/plugin/localizedFormat"
// dayjs.extend(localizedFormat)
// dayjs.extend(relativeTime)
// dayjs.extend(isSameOrAfter)
// dayjs.extend(isSameOrBefore)

import customParseFormat from "dayjs/plugin/customParseFormat.js"

dayjs.extend(customParseFormat)
dayjs.locale("de")
dayjs.extend(isSameOrAfter)

export default dayjs
